import React from "react";
import SubscriptionIcon from '../icons/SubscriptionIcon.png';
import { BASE_PATH } from "../constants/awsBaseUrl";

//these effect the live and playist thumbnails
class PreviewSpecial extends React.Component {

  constructor(props) {
    super(props);
    this.ref = React.createRef();
    this.state = { height: 110, failed: false, loaded: false };
  }

  componentDidMount() {
    if(this.ref.current) {
      this.setState({ height: this.ref.current.clientWidth * 0.556 });
    }
  }

  render() {
    return (
      <div className="thumbnail" ref={this.ref}>
        <img
          className="thumbnail-img"
          style={this.state.loaded ? { filter: this.props.notAccessible ? 'brightness(0.3)' : null } : { display: "none" }}
          src={`${BASE_PATH}/${
              this.props.type
              }/thumbs/${
                this.props.item
              }/thumb.jpg?refresh=${
                new Date().getMonth()}${
                new Date().getDate()}${
                new Date().getFullYear()
              }`}
          onLoad={() => this.setState({ loaded: true, failed: false })}
          onError={() => {this.setState({failed: true})}}
          alt=""
          
        />
  
         {this.props.notAccessible &&  <img className="thumbnail-lock-icon" src={SubscriptionIcon} alt='subscription icon'  />}
        
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
            width: "100%",
            padding: "25%",
          }}
        >
          <i
            className="fas fa-spinner fa-2x "
            style={{ 
              color: this.props.color, 
              visibility: this.state.failed || this.state.loaded ? 'hidden' : ''
            }}
          ></i>
        </div>
      </div>
    );
  }
}
export default PreviewSpecial;
